// Modules
import cn from 'classnames';

// Types
import type { TAvatarProps } from './Avatar.type';

// Styles
import styles from './styles.module.scss';

// Constants
import { AVATAR_DEFAULT_PROPS } from './Avatar.constant';

const Avatar = (props: TAvatarProps) => {
	const {
		alt = AVATAR_DEFAULT_PROPS.alt,
		children,
		className,
		imageClassName,
		size = AVATAR_DEFAULT_PROPS.size,
		src,
		...restProps
	} = props

	const avatarCN = cn(styles.legion_avatar, className, styles[size!])
	const avatarImageCN = cn(styles.legion_avatar_image, imageClassName)

	return (
		<div className={avatarCN} {...restProps}>
			{src ? (<img className={avatarImageCN} src={src} alt={alt}/>) : children}
		</div>
	)
}

export default Avatar;
